"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpContext = void 0;
const react_1 = require("react");
exports.HelpContext = (0, react_1.createContext)({
    formContextHelpType: 'CLICKABLE',
});
//# sourceMappingURL=help-context.js.map